<template lang="html">
<div class="table-item">
    <div class="checkbox-wrap">
      <CustomCheckbox
        :is-checked="isChecked"
        @toggle="$emit('toggle', { id: $props.item.id, target: $props.selectedTab })"
      />
    </div>
    <div class="item-wrap" >
      <span class="item-name">
        {{item.name}}
      </span>
      <EntityTypeLabel
        v-if="isItemEntity"
        class="type-label"
        :entityType="item.type"
      />
    </div>
</div>
</template>

<script>
import has from 'lodash/has'
import { ENTITY_TYPE } from '@/components/model/nlu-model/sidebar/entities/entity-types'
import CustomCheckbox from '@/components/common/custom_checkbox'
import EntityTypeLabel from '@/components/model/common/EntityTypeLabel'

export default {
  components: {
    CustomCheckbox,
    EntityTypeLabel
  },

  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    selectedTab: String,
    selectedItems: {
      type: Object,
      default: () => ({ responses: [], entities: [] })
    }
  },

  computed: {
    isChecked () {
      return this.selectedItems[`${this.$props.selectedTab}`].includes(this.item.id)
    },

    isItemEntity () {
      return has(this.$props.item, 'type')
    },

    isMlEntity () {
      return this.isItemEntity
        ? this.$props.item.type === ENTITY_TYPE.machineLearning
        : false
    }
  }
}
</script>

<style lang="scss" scoped>
.table-item {
    display: flex;
    flex-grow: 1;
    min-height: 36px;
    border: solid 1px $or-grey-medium;
    border-top: none;

    &:last-child {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      margin-bottom: 32px;
    }

    .checkbox-wrap {
      display: flex;
      align-items: center;
      border-right: solid 1px $or-grey-medium;
      padding: 0 10px;
    }

    .item-wrap {
      display: flex;
      flex-grow: 1;
      align-items: center;
      padding: 0 8px;

      .item-name {
        font-size: 14px;
      }

      .type-label {
        margin-left: auto;
      }
    }
}
</style>
